import script from "./KItemCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KItemCard.vue?vue&type=script&setup=true&lang=ts"

import "./KItemCard.vue?vue&type=style&index=0&id=ec07bf60&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec07bf60"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
